module.exports = __webpack_public_path__ + "NewLogoTurkeyMini.png?4f06f21a908c8989c2c543d5ae4bf695";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NewLogoTurkeyMini.png
// module id = 32
// module chunks = 0